module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc",
    attrs: {
      "id": "toc"
    }
  }, [_c('p', {
    staticClass: "Head"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('a', {
    attrs: {
      "href": "#/08_ThenandNowbook_introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('a', {
    attrs: {
      "href": "#/09_ThenandNowbook_map"
    }
  }, [_vm._v("Map of Vaughn’s Montana")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('a', {
    attrs: {
      "href": "#/10_ThenandNowbook_ch01"
    }
  }, [_vm._v("From Home to the State of Illinois.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('a', {
    attrs: {
      "href": "#/11_ThenandNowbook_ch02"
    }
  }, [_vm._v("Crossing the Plains.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('a', {
    attrs: {
      "href": "#/12_ThenandNowbook_ch03"
    }
  }, [_vm._v("On a Stampede to the Yellowstone.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('a', {
    attrs: {
      "href": "#/13_ThenandNowbook_ch04"
    }
  }, [_vm._v("The Discovery of Alder Creek, the Richest Gulch on the Globe.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('a', {
    attrs: {
      "href": "#/14_ThenandNowbook_ch05"
    }
  }, [_vm._v("The James Stuart Prospecting Party.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/15_ThenandNowbook_ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Alder Gulch to Last Chance.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/16_ThenandNowbook_ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From the Mines to the Farm.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/17_ThenandNowbook_ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Letter to My Little Babe.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/18_ThenandNowbook_ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From the Farm to the City of Great Falls.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/19_ThenandNowbook_ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Montana’s Pioneers.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/20_ThenandNowbook_ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dark Side of the Life of the Pioneer.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/21_ThenandNowbook_ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Indian Praying.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/22_ThenandNowbook_ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Indians Stealing My Horses.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/23_ThenandNowbook_ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Great Sun River Stampede.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/24_ThenandNowbook_ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Trip from Virginia City to the Head of Navigation on the Missouri River in 1866.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/25_ThenandNowbook_ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My First Buffalo Hunt.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/26_ThenandNowbook_ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tom Campbell Running the Gauntlet.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/27_ThenandNowbook_ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edward A. Lewis’ Early Days in Montana.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/28_ThenandNowbook_ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Brave Piegan War Chief.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/29_ThenandNowbook_ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bloody Battles and Tragedies in the Sun River Valley.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/30_ThenandNowbook_ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charles Choquette Coming to Montana in 1843.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/31_ThenandNowbook_ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Trip to the Twenty-eight Mile Spring Station.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/32_ThenandNowbook_ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Largent’s Early Days in Montana.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/33_ThenandNowbook_ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Visit to Fort Benton.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/34_ThenandNowbook_ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John D. Brown: A Narrative of His Early Experience in the West.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/35_ThenandNowbook_ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Pioneer Minister.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/36_ThenandNowbook_ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Old Letter.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/37_ThenandNowbook_ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Warren C. Gillette’s Early Experiences in Montana.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/38_ThenandNowbook_ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Meal in the Indian Camp.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/39_ThenandNowbook_ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Settlement of What Is Now Montana.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/40_ThenandNowbook_ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Montana Then and Now.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/41_ThenandNowbook_ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Sample of the Pioneers of Montana.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/42_ThenandNowbook_ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Indian.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/43_ThenandNowbook_ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sioux War.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/44_ThenandNowbook_ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("General Sherman’s Letters.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/45_ThenandNowbook_ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nez Perces War.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/46_ThenandNowbook_ch37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An English Tribute to the American Scout.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/47_ThenandNowbook_ch38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Returning of Sitting Bull from Canada.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/48_ThenandNowbook_ch39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Indian Messiah and the Ghost Dance.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/49_ThenandNowbook_ch40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Indian Legend.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/50_ThenandNowbook_ch41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Round-up.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/51_ThenandNowbook_ch42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traveling “Then” And Traveling “Now.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/52_ThenandNowbook_ch43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yellowstone National Park.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/53_ThenandNowbook_ch44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From the Prospector’s Hole to the Greatest Mining Camp on Earth.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7819a56e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/07_ThenandNowbook_contents.vue
// module id = 72
// module chunks = 0